'use client';

import React from 'react';
import useEffectOnce from 'react-use/lib/useEffectOnce';
import { UseThemeMode } from '../hooks/UseThemeMode';
import { useThemeStore } from '../stores/ThemeStore';
import { useUIStore } from '../stores/UIStore';
import { updateAllThemes } from '../styles/themeGenerator';
import { ThemeModes } from '../types/theme';
import { ThemeModeToggle } from './ThemeModeToggle';

export const ThemeModeToggleContainer = () => {
  const [mounted, setMounted] = React.useState<boolean>(false);

  const themeMode = useUIStore(state => state.themeMode);

  const { handleThemeToggle } = UseThemeMode();
  const storeThemeConfigs = useThemeStore(state => state.themeConfigs);

  useEffectOnce(() => {
    setMounted(true);
  });

  const handleThemeToggleCustom = React.useCallback(
    (_ev: React.MouseEvent<HTMLElement>) => {
      handleThemeToggle();

      if (!storeThemeConfigs) return;

      const newThemeMode = themeMode === ThemeModes.Light ? ThemeModes.Dark : ThemeModes.Light;
      // update only current theme
      // const currentConfig = storeThemeConfigs?.find(config => config.id === theme);
      // if (currentConfig) updateTheme(currentConfig, newThemeMode);

      // update all themes
      updateAllThemes(storeThemeConfigs, { themeMode: newThemeMode });
    },
    [handleThemeToggle, storeThemeConfigs, themeMode]
  );

  return <ThemeModeToggle themeMode={mounted ? themeMode : ThemeModes.System} onClick={handleThemeToggleCustom} />;
};
